/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('dosageService',dosageService);

    dosageService.$inject = ['$http', 'CONFIG','messageService'];

    function dosageService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/dosages';

        var service = {
            getDosages: getDosages,
            getPageDosages: getPageDosages,
            getDosage: getDosage,
            getDosageActiveByEconomicActivity: getDosageActiveByEconomicActivity,
            saveDosage: saveDosage,
            updateDosage: updateDosage,
            deleteDosage: deleteDosage
        };

        return service;

        function getDosages(detailed){
            return $http.get(urlBase + "?detailed="+detailed)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.dosages : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getPageDosages(page, size, detailed){
            return $http.get(urlBase + "/" + 'page?detailed='+detailed+'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getDosage(id){
            return $http.get(urlBase + "/" + id)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('dosages');
                });
        }

        function getDosageActiveByEconomicActivity(id){
            return $http.get(urlBase + "/" + id + "/byEconomicActivityAndStateActive")
                .then(function(response){
                    return (response.data) ? response.data : undefined;
                }, function(){
                    return undefined;
                });
        }

        function saveDosage(dosage){
            return $http.post(urlBase, dosage)
                .then(function(){
                    messageService.register('dosages');
                }, function(){
                    messageService.registerError('dosages');
                });
        }

        function updateDosage(dosage, id){
            return $http.put(urlBase + "/" + id, dosage)
                .then(function(){
                    messageService.registerUpdate('dosages');
                }, function(){
                    messageService.registerUpdateError('dosages');
                });
        }

        function deleteDosage(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('dosages');
                }, function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('dosages','air.dosage.associatedInvoices');
                    }else{
                        messageService.registerDeleteError('dosages');
                    }
                })
        }
    }
})();
